<template>
  <div class="showTheLogin">
    <div class="loginCent">
      <nav>
        <div class="hiddenLoginBtn">
          <a class="el-icon-close" @click="hiddenLoginBtn" />
        </div>
      </nav>
      <div class="loginForm">
        <!-- <div class="loginTit" v-text="isRegistered == '1' ? '注册' : '登录'"></div> -->
        <div class="loginTitle">
          <div class="title"  v-text="isRegistered !== '1' ? '登录' : '用户注册'"></div>
          <div class="content">
            <span v-text="isRegistered === '1' ? '已有账户？' : '第一次使用沂商通商城？'"></span>
            <u @click="registered" v-text="isRegistered === '1' ? '立即登录' : '用户注册'"></u></div>
        </div>
        <div class="loginFormBox">
          <div class="inputBox">
            <el-input v-model="userName" placeholder="请输入您的手机号码">
              <template slot="prepend"><span class="icon iconfont">&#xe62f;</span></template>
            </el-input>
          </div>
          <div class="inputBox">
            <el-input
              v-model="verificationCode"
              placeholder="请输入验证码"
              @keyup.enter.native="login"
            >
              <template slot="prepend">
                <span class="icon iconfont">&#xe62e;</span>
              </template>
            </el-input>
            <span v-show="codeShow" class="codeBtn" @click="getCode">获取验证码</span>
            <span v-show="!codeShow" class="codeBtn codeCount">重新获取({{codeCountNum}}s)</span>
          </div>
          <div class="noLogin" :class="{registered: isRegistered === '1'}" >
            <el-checkbox v-show="isRegistered === '2'" v-model="isNoLogin">七天免登录</el-checkbox>
            <span ></span>
          </div>
          <el-button class="loginBtn"
            @click="login"
            v-text="isRegistered === '1' ? '注册' : '立即登录'"
            :loading="loadingLogin"
          >立即登录</el-button>
        </div>
        <div class="loginProtocol" v-if="isRegistered === '1'">
          <el-checkbox v-model="haveRead"></el-checkbox>
          <span>阅读并同意</span>
          <span @click="readAgreement">《沂商通商城 服务协议》</span>
        </div>
      </div>
    </div>
    <el-dialog
      title="服务协议"
      :visible.sync="dialogAgreement"
      width="60%">
      <div class="xieyi">
        <div class="title"><span>沂商通服务协议</span></div>
        <div class="con">
          <div class="con_title">1. 特别提示</div>
          <div class="con_con">
            <p>1.1 沂商通同意按照本协议及其不时发布的操作规则提供基于互联网的相关服务（以下称“网络服务”）。为获得网络服务，服务使用人（以下称“用户”）应当同意本协议的全部条款并按照页面上的提示完成全部的注册程序。用户在注册过程中点击“同意”按钮即表示用户完全接受本协议项下的全部条款。</p>
          </div>
          <div class="con_title">2. 条款的确认和接受</div>
          <div class="con_con">
            <p>2.1 您在申请注册流程之前，应当认真阅读本协议，如您对协议有任何疑问，可向沂商通平台客服咨询，如果您不同意本协议或其中任何条款约定，您应立即停止注册程序。</p>
            <p>2.2 您完成注册程序后或以任何方式进入沂商通并使用本网站服务即表示您已充分阅读、理解并同意接受本协议的条款，并与沂商通达成一致，成为沂商通 “注册用户”。</p>
            <p>2.3 若您在沂商通有信息发布的需求，请在注册时提供真实身份信息。若您不提供真实身份信息，根据《网络安全法》第24条规定，沂商通不为您提供相关服务。</p>
          </div>
          <div class="con_title">3. 服务内容</div>
          <div class="con_con">
            <p>3.1 沂商通网络服务的具体内容由沂商通根据实际情况提供，例如客户留言、发布公司或个人信息等。沂商通保留随时变更、中断或终止部分或全部网络服务的权利。</p>
            <p>3.2 用户理解，沂商通仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如电脑、调制解调器及其他与接入互联网有关的装置）及所需的费用（如为接入互联网而支付的电话费及其他费用）均应由用户自行负担。</p>
          </div>
          <div class="con_title">4. 使用规则</div>
          <div class="con_con">
            <p>4.1 用户在申请使用沂商通网络服务时，必须向沂商通提供真实、准确的个人资料，如个人资料有任何变动，必须及时更新。同时承诺自己填的信息是真实的！</p>
            <p>4.2 用户注册成功后，沂商通将给予每个用户一个用户帐号及相应的密码，该用户帐号和密码由用户负责保管；用户应当对以其用户帐号进行的所有活动和行为负法律责任。用户发布的产品信息、商业广告内容由用户承担法律责任，沂商通不参与用户发布的产品信息、商业广告内容，不承担任何责任。</p>
            <p>4.3 用户同意接受沂商通通过电子邮件或其他方式向用户发送的商品促销或其他相关商业信息。</p>
            <p>4.4 用户在使用沂商通网络服务过程中，必须遵循以下原则： (a) 遵守中国有关的法律和法规； (b) 不得为任何非法目的而使用网络服务系统； (c) 遵守所有与网络服务有关的网络协议、规定和程序； (d) 不得利用沂商通网络服务系统进行任何可能对互联网的正常运转造成不利影响的行为； (e)不得利用沂商通网络服务系统进行任何不利于沂商通的行为； (g) 如发现任何非法使用用户帐号或帐号出现安全漏洞的情况，应立即通告沂商通。</p>
            <p>4.5 用户在使用沂商通网络服务过程中，不得制作、复制、发布、传播含有下列内容的信息：</p>
            <p>（一）反对宪法所确定的基本原则的；</p>
            <p>（二）危害国家安全，泄露国家秘密，颠覆国家，破坏国家统一的；</p>
            <p>（三）损害国家荣誉和利益的；</p>
            <p>（四）煽动民族仇恨、民族歧视，破坏民族团结的；</p>
            <p>（五）破坏国家宗教政策，宣扬邪教和封建迷信的；</p>
            <p>（六）散布谣言，扰乱社会秩序，破坏社会稳定的；</p>
            <p>（七）散布淫秽教唆犯罪的；</p>
            <p>（八）侮辱或者诽谤他人，侵害他人合法权益的；</p>
            <p>（九）含有法律、行规禁止的其他内容的。</p>
            <p>沂商通发现用户传输的信息明显属于上述内容之一的，应立即停止传输，保存有关记录，并向国家有关机关报告。</p>
            <p>4.6 任何个人和组织应当对其使用网络的行为负责，不得设立用于实施诈骗，传授犯罪方法，制作或者销售违禁物品、管制物品等违法犯罪活动的网站、通讯群组，不得利用网络发布涉及实施诈骗，制作或者销售违禁物品、管制物品以及其他违法犯罪活动的信息。</p>
          </div>
          <div class="con_title">5. 网络信息的使用</div>
          <div class="con_con">
            <p>5.1 沂商通网站内所包含的资讯、内容、广告等相关信息，均来自注册会员或者客户自行提供，或互联网络。沂商通对此等信息的准确性、完整性、合法性或者真实性均不承担任何责任。网络卖家不得发布侵犯他人合法权益的商品信息，承诺不得发布侵犯他人知识产权的信息。</p>
            <p>5.2 用户只有在获得沂商通或其他相关权利人的授权之后才能使用这些内容，而不能擅自复制、再造这些内容，或创造与内容有关的派生产品。</p>
          </div>
          <div class="con_title">6. 免责声明</div>
          <div class="con_con">
            <p>6.1 用户明确同意其使用沂商通网络服务所存在的风险将完全由其自己承担；因其使用沂商通网络服务而产生的一切后果也由其自己承担，沂商通对用户不承担任何责任。</p>
            <p>6.2 沂商通不担保其提供的网络服务一定能满足用户的要求，也不担保网络服务不会中断，对网络服务的及时性、安全性、准确性均不作担保。</p>
          </div>
          <div class="con_title">7. 服务变更、中断或终止</div>
          <div class="con_con">
            <p>7.1 如因系统维护或升级的需要而需暂停网络服务，沂商通将尽可能事先进行通告。</p>
            <p>7.2 如发生下列任何一种情形，沂商通有权随时中断或终止向用户提供本协议项下的网络服务而无需通知用户：(a) 用户提供的个人资料不真实。 (b) 用户违反本协议中规定的使用规则。</p>
            <p>7.3 沂商通有权在必要时修改服务规则。沂商通的服务规则一旦发生变动，将会在沂商通的重要页面上提示修改内容，用户如不同意新的修改内容，须立即停止使用本协议约定的服务，否则视为用户完全同意并接受新的修改内容。根据客观情况及经营方针的变化，沂商通有中断或停止服务的权利，用户对此表示理解并完全认同，沂商通无需对用户或任何第三方承担任何责任。</p>
            <p>沂商通（www.mlinyi.com）依据本协议的规定提供服务，本协议具有合同效力。您已知悉且同意以下所有条款并完成个人资料的填写，才能保证享受到沂商通提供的网络服务。我台承诺在服务过程中收集到的您个人信息，将严格遵循合法、正当、必要的原则，您使用服务的行为将视为对本协议的接受，并同意接受本协议各项条款的约束。</p>
          </div>
          <div class="con_title">个人信息的范围</div>
          <div class="con_con">
            <p>沂商通向您收集的个人信息系能单独或者与其他信息相结合识别您的个人身份的信息，包括但不限于您的姓名、联系电话、电子邮箱、住址、账户密码、贵公司名称、所在地、理区域等个人信息，上述个人信息是您获得我平台提供服务的基础，该等信息均是您自愿提供。</p>
          </div>
          <div class="con_title">个人信息的保护</div>
          <div class="con_con">
            <p>沂商通将尽一切合理努力保护其获得的用户个人信息，遵守相关法律规定要求的标准，但沂商通仍然无法保证您的个人信息的绝对安全性。因此，用户个人应采取积极措施保证个人信息的安全，如：不将自己的帐号密码等个人信息透露给他人。</p>
            <p>您知悉：沂商通提供的个人信息保护措施仅适用于沂商通平台，一旦您离开沂商通，浏览或使用其他网站、服务及内容资源，沂商通即没有能力及义务保护您在沂商通以外的网站提交的任何个人信息，无论您登录或浏览上述网站是否基于沂商通的链接或引导。</p>
            <p>沂商通发现法律、行政法规禁止发布或者传输的信息的，将立即停止传输该信息，采取消除等处置措施，防止信息扩散，保存有关记录，并向有关主管部门报告。</p>
          </div>
          <div class="con_title">个人信息的披露</div>
          <div class="con_con">
            <p>未经您本人允许，沂商通不会向任何第三方披露您的个人信息，下列情形除外：</p>
          </div>
          <div class="con_title">信息安全</div>
          <div class="con_con">
            <p>1)沂商通已经取得您或您监护人的授权；</p>
            <p>2)司法机关或行政机关给予法定程序要求沂商通披露的；</p>
            <p>3)沂商通为维护自身合法权益而向用户提起诉讼或仲裁时；</p>
            <p>4)法律法规规定的其他情形。</p>
          </div>
          <div class="con_title">投诉和举报</div>
          <div class="con_con">
            <p>沂商通在网站首页的底部设置有网络信息安全投诉、举报的链接，用户可通过客服QQ、投诉电话、不良信息举报中心网站链接、经营性网站备案信息网站链接投诉举报，沂商通受理后将及时依法处理。</p>
          </div>
          <div class="con_title">个人信息保密协议修改</div>
          <div class="con_con">
            <p>沂商通有权在必要时修改本协议，一旦本协议内容发生变动，将会在本网站的重要页面上提示发布修改之后的《个人信息保密协议》，该提示发布行为视为沂商通已经通知您修改行为。沂商通也可通过其他适当方式向用户提示修改内容。用户如不同意新的修改内容，须立即停止使用本协议约定的服务，否则视为用户完全同意并接受新的修改内容。根据客观情况及经营方针的变化，本网站有中断或停止服务的权利，用户对此表示理解并完全认同。</p>
            <p>本保密协议的解释权归沂商通所有</p>
          </div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import Cookie from 'js-cookie'
import store from '@/store/index.js'
import {
  getTheCode,
  login
} from '@/api/login.js'
import {
  getUserInfo
} from '@/api/user/user.js'
export default {
  name: 'login',
  data () {
    return {
      userName: '',
      verificationCode: '',
      isNoLogin: false,
      haveRead: false,
      codeShow: true,
      codeCountNum: '',
      dialogAgreement: false,
      isRegistered: '2',
      loadingLogin: false
    }
  },
  methods: {
    async getUserInfoData () {
      const response = await getUserInfo()
      const res = response.data
      if (res.code === '200') {
        store.commit('SET_USERINFO', res.data)
        this.userInfoData = res.data
      }
    },
    async getCode () {
      const TIME_COUNT = 120
      let reg = /^1[13456789]\d{9}$/
      if (!reg.test(this.userName)) {
        this.$message({
          message: '手机号格式错误',
          type: 'error',
          customClass: 'messageZindex',
        })
        return
      }
      const response = await getTheCode({ phone: this.userName })
      const res = response.data
      if (res.code === '200') {
        if (!this.timer) {
          this.codeCountNum = TIME_COUNT
          this.codeShow = false
          this.timer = setInterval(() => {
            if (this.codeCountNum > 0 && this.codeCountNum <= TIME_COUNT) {
              this.codeCountNum--
            } else {
              this.codeShow = true
              clearInterval(this.timer)
              this.timer = null
            }
          }, 1000)
        }
        this.$message({
          message: '验证码获取成功',
          type: 'success',
          customClass: 'messageZindex'
        })
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
    },
    // 阅读协议
    readAgreement () {
      this.dialogAgreement = true
    },
    login () {
      let reg = /^1[13456789]\d{9}$/
      if (!reg.test(this.userName)) {
        this.$message({
          message: '手机号码格式错误',
          type: 'error',
          customClass: 'messageZindex'
        })
        return
      }
      if (this.verificationCode === '') {
        this.$message({
          message: '请输入验证码',
          type: 'warning',
          customClass: 'messageZindex'
        })
        return
      }
      if (this.isRegistered === '2') {
        this.getLogin()
      } else if (this.haveRead) {
        this.getLogin()
      } else {
        this.$message({
          message: '请阅读并同意服务协议',
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
    },
    async getLogin () {
      this.loadingLogin = true
      const response = await login({
        phone: this.userName,
        verificationCode: this.verificationCode,
        type: this.isRegistered
      })
      const res = response.data
      if (res.code === '200') {
        if (this.isNoLogin) {
          Cookie.set('token', res.data.token, { expires: 7 })
        } else {
          Cookie.set('token', res.data.token, { expires: 1 })
        }
        this.getUserInfoData()
        this.$message({
          message: '登录成功',
          type: 'success',
          customClass: 'messageZindex'
        })
        store.commit('SHOW_LOGIN')
        store.commit('IS_LOGIN', true)
        location.reload()
      } else {
        this.$message({
          message: res.message,
          type: 'warning',
          customClass: 'messageZindex'
        })
      }
      this.loadingLogin = false
    },
    registered () {
      this.codeShow = true
      clearInterval(this.timer)
      this.timer = null
      this.userName = ''
      this.verificationCode = ''
      if (this.isRegistered === '1') {
        this.isRegistered = '2'
      } else {
        this.isRegistered = '1'
      }
    },
    // 关闭登录
    hiddenLoginBtn () {
      store.commit('SHOW_LOGIN')
    }
  }
}
</script>

<style lang="scss" scoped>
.showTheLogin {
  // height: 100vh;
  // min-height: 768px;
  position: fixed;
  z-index: 9999;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  .loginCent {
    // background: url('../../assets/images/beijing.png') no-repeat;
    // flex-grow: 1;
    // background-size: cover;
    width: 500px;
    height: 100%;
    min-height: 768px;
    padding: 20px 50px;
    float: right;
    background-color: #ffffff;
    animation: showRight .5s;
    animation-fill-mode:forwards;
    -webkit-animation-fill-mode:forwards;
    nav{
      margin-bottom: 85px;
      .hiddenLoginBtn{
        a{
          float: right;
        }
      }
    }
    .loginForm {
      width: 500px;
      height: 100%;
      background: #ffffff;
      .loginTitle{
        font-family: Microsoft YaHei;
        color: #333333;
        .title{
          font-size: 36px;
        }
        .content{
          margin: 10px 0;
          font-size: 14px;
          u{
            color: #C5AA7B;
            cursor: pointer;
          }
        }
      }
      .loginFormBox {
        .inputBox {
          position: relative;
          .el-input{
            .iconfont{
              font-size: 32px;
              padding: 0 10px;
            }
          }
          >>> .el-input__inner {
            height: 70px;
            background: #F3F4F5;
            border-radius: 0px;
            font-size: 20px;
            padding-left: 5px;
          }
          &:nth-child(2) {
            margin: 60px 0 20px 0;
          }
          .codeBtn {
            width: 120px;
            height: 50px;
            background: $mainGlod;
            border-radius: 0;
            display: block;
            line-height: 54px;
            text-align: center;
            position: absolute;
            right: 5px;
            bottom: 10px;
            cursor: pointer;
          }
          .codeCount {
            color: #999999;
          }
        }
        .noLogin {
          color: #333333;
          font-size: 18px;
          margin:20px 0 60px 0;
          height: 30px;
          align-items: center;
          display: flex;
          justify-content: space-between;
          >>> .el-checkbox__label {
            font-size: 16px;
            color: #333333;
            font-weight: 400;
          }
          span {
            cursor: pointer;
            font-size: 16px;
            text-decoration: underline;
            color: #666666;
          }
        }
        .registered {
          justify-content: flex-end;
        }
        .loginBtn {
          width: 100%;
          height: 70px;
          background: #333333;
          border-radius: 0;
          border: 1px solid #333333;
          text-align: center;
          font-size: 20px;
          color: $mainGlod;
          cursor: pointer;
          &:hover{
            border: 1px solid $mainGlod;
          }
        }
      }
      .loginProtocol {
        padding: 0 60px;
        display: flex;
        align-items: center;
        height: 80px;
        line-height: 80px;
        border-top: 1px solid #EEEEEE;
        span {
          margin-left: 10px;
        }
        span:nth-child(3) {
          color: #426BEA;
          cursor: pointer;
        }
      }
      >>> .el-checkbox__inner {
        width: 20px;
        height: 20px;
        &:after {
          height: 10px;
          left: 7px;
          width: 4px;
        }
      }
    }
  }
  >>> .el-dialog__body {
    max-height: 500px;
    min-height: 300px;
    overflow: auto;
  }
}
.hiddenLogin {
  display: none;
}
@keyframes showRight {
  from {
    width: 560px;
    opacity: 0;
  }
  to {
    width: 600px;
    opacity: 1;
    display: block;
  }
}
.xieyi{
  display: flex;
  flex-direction: column;
  align-items: center;
  .title{
    color: #000;
    font-size: 25px;
    font-weight: bold;
    margin-bottom: 10px;
  }
  .con{
    text-align: left;
  }
  .con_title{
    font-size: 16px;
    font-weight: 600;
    color: #555;
    text-indent:34px;
    margin-top: 10px;
    margin-bottom: 10px;
  }
  .con_con{
    font-size: 17px;
    color: #555;
    line-height: 30px;
    text-indent:34px;
    p{
      padding-bottom: 5px;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/login/login.vue